// import { useRef } from 'react';
import { useState, useEffect, useRef } from 'react';
import { PageInfo } from "./App";
import { useHeading } from './HeadingContext';

type activeFunc = (page: string) => void;
type PageProps = {
    activePageId: string;
    allPages: PageInfo[];
    setActivePageId: activeFunc;
}

const activeLinkColor = "border-secondary";
const inactiveLinkColor = "border-transparent";

const logo = "/favicon.ico";

export function Heading({ activePageId, allPages, setActivePageId }: PageProps) {
    const headingRef = useRef<HTMLDivElement>(null);
    const { setHeadingHeight, setMinHeight } = useHeading()!;
    const [backgroundWhite, setBackgroundWhite] = useState(true);
    const [isVerticalNavVisible, setIsVerticalNavVisible] = useState(false);
    

    useEffect(() => {
        const height = headingRef.current?.offsetHeight ?? 0;
        // Assuming you have a state or method to set the height in your context provider
        setHeadingHeight(height);
        setMinHeight(`${window.innerHeight - height}px`);
    }, []);

    useEffect(() => {
        const page = document.getElementsByClassName(activePageId)[0];
        if (page) {
            setBackgroundWhite(window.getComputedStyle(page!).backgroundColor === "rgb(255, 255, 255)")
        }
    }, [activePageId])
    
    return (
        <>
            <div className='w-full fixed left-0 top-0 flex sm:hidden justify-start pt-2 px-2 z-50'>
                <button className='flex justify-center items-center bg-white rounded-md shadow-lg p-1'
                        onClick={() => {setIsVerticalNavVisible(prevState => !prevState)}}>
                    <svg className={`w-6 ${isVerticalNavVisible ? 'sidebar-open' : 'sidebar-closed'} z-1000`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg>
                </button>
            </div>
                <nav className={`fixed flex flex-col justify-between left-0 top-0 h-full w-[24vw] min-w-20 bg-off_white z-40 shadow-lg ${isVerticalNavVisible ? 'vnav-in' : 'vnav-out'}`}>
                    <div className='pl-2 pt-6'>
                        <div className="my-10 flex flex-col justify-between space-y-3 sm:space-y-6 md:space-y-9 lg:space-y-12 text-secondary normal-size">
                            {PageProcess(activePageId, allPages[1], setActivePageId, "normal")}
                            {PageProcess(activePageId, allPages[2], setActivePageId, "normal")}
                            {PageProcess(activePageId, allPages[3], setActivePageId, "normal")}
                            <div className='mx-auto'>
                                {PageProcess(activePageId, allPages[4], setActivePageId, "button")}
                            </div>
                        </div>
                    </div>
                    <img src={logo} alt="elk logo" />
                </nav>
            <nav ref={headingRef} id='horizontal-navbar' className={`sticky top-0 w-full z-50 ${backgroundWhite ? "bg-off_white" : "bg-white"} min-h-10 h-[10vh] xl:h-[8vh] navbar hidden sm:flex flex-row justify-between items-center shadow-lg`}>
                {PageProcess(activePageId, allPages[0], setActivePageId, "logo")}

                <div className="mx-2 my-1 flex flex-row justify-between space-x-3 sm:space-x-6 md:space-x-9 lg:space-x-12 text-secondary">
                    {PageProcess(activePageId, allPages[1], setActivePageId, "normal")}
                    {PageProcess(activePageId, allPages[2], setActivePageId, "normal")}
                    {PageProcess(activePageId, allPages[3], setActivePageId, "normal")}
                    {PageProcess(activePageId, allPages[4], setActivePageId, "button")}
                </div>
            </nav>
        </>
    )
}

const GetToPage = (pageId: string, setActivePageId: activeFunc) => {
    // Detect if window is size sm
    const isSmall = window.matchMedia('(max-width: 640px)').matches;

    if (isSmall) {
        document.getElementById(`${pageId}`)?.scrollIntoView({ behavior: 'smooth' });
    }
    else {
        document.getElementById(`${pageId}-header-holder`)?.scrollIntoView({ behavior: 'smooth' })
    }

    setActivePageId(pageId)
}


const PageProcess = ( activePageId : string, page : PageInfo, setActivePageId : activeFunc, type: string) => {
    let isActive = activePageId == page.id;
    return (
    <div 
        style={{
            display: 'flex', 
            alignItems: 'center',
            cursor: "pointer"
        }}
        onClick={()=>{
            GetToPage(page.id, setActivePageId)
    }}>
        {type === "logo" ? <div className="title py-0 px-5">ELK</div> : 
        type === "button" ? <button className="contact-button mr-2 my-2">Contact</button> : 
        <div className={`nav-link justify-center ${isActive ? activeLinkColor : inactiveLinkColor}`}>{page.navTitle}</div>}
    </div>)
}
 
export default Heading;